export enum VersionPath {
  Version1 = 'v1'
}
